function isMobileDevice() {
  if (
    navigator.platform === "MacIntel" &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 1
  )
    return true;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}

function isIpadPro() {
  if (/iPad/.test(navigator.userAgent)) return true;

  if (
    navigator.platform === "MacIntel" &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 1
  )
    return true;
  return false;
}

function checkRotateScreen() {
  if (!isMobileDevice()) {
    $(".layer-rotate").hide();
    return;
  }

  const isLandscape =
    window.matchMedia && window.matchMedia("(orientation: landscape)").matches
      ? true
      : window.innerWidth > window.innerHeight;

  if (isLandscape) {
    if (!isIpadPro()) {
      $(".layer-rotate").show();
    } else {
      $(".layer-rotate").hide();
    }
  } else {
    $(".layer-rotate").hide();
  }
}
$(function () {
  checkRotateScreen();

  let resizeTimer = null;
  function debouncedCheck() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      checkRotateScreen();
      resizeTimer = null;
    }, 120);
  }

  window.addEventListener("resize", debouncedCheck, { passive: true });
  window.addEventListener("orientationchange", debouncedCheck, {
    passive: true,
  });

  if (isIpadPro()) {
    let lastOrientation =
      window.matchMedia && window.matchMedia("(orientation: portrait)").matches
        ? "portrait"
        : window.matchMedia &&
            window.matchMedia("(orientation: landscape)").matches
          ? "landscape"
          : window.innerWidth > window.innerHeight
            ? "landscape"
            : "portrait";
    let ipadReloadTimer = null;
    function handleIpadOrientationChange() {
      const current =
        window.matchMedia &&
        window.matchMedia("(orientation: portrait)").matches
          ? "portrait"
          : window.matchMedia &&
              window.matchMedia("(orientation: landscape)").matches
            ? "landscape"
            : window.innerWidth > window.innerHeight
              ? "landscape"
              : "portrait";
      if (current === lastOrientation) return;
      lastOrientation = current;
      if (ipadReloadTimer) clearTimeout(ipadReloadTimer);
      ipadReloadTimer = setTimeout(() => {
        location.reload();
      }, 200);
    }
    window.addEventListener("orientationchange", handleIpadOrientationChange, {
      passive: true,
    });

    window.addEventListener("resize", handleIpadOrientationChange, {
      passive: true,
    });
  }
});

let swiper;

// Lazy-load nền slide: set src từ data-src cho slide active + slide kế tiếp.
// Chạy sau khi lib đã remove MS__pc/MS__mb nên chỉ còn 1 biến thể -> không double-load.
function loadSlideLazy(idx) {
  const slides = document.querySelectorAll(".main-swiper > .swiper-wrapper > .swiper-slide");
  [idx, idx + 1].forEach(function (i) {
    const s = slides[i];
    if (!s) return;
    // Loại trừ .mp-bg/.mp-bg-mb: nền phái frame4 do emblem-click tự quản (giữ on-demand riêng)
    s.querySelectorAll("img[data-src]:not(.mp-bg):not(.mp-bg-mb)").forEach(function (im) {
      if (!im.getAttribute("src")) im.setAttribute("src", im.getAttribute("data-src"));
    });
  });
}

function initMainSwiper(retry = 0) {
  if ($("#MS__wrapper.iframe").length > 0 || $(".main-swiper").length === 0) return;

  if (swiper) return;
  if (typeof window.Swiper === "undefined") {
    if (retry < 20) {
      setTimeout(function () {
        initMainSwiper(retry + 1);
      }, 100);
    } else {
      console.error("Swiper CDN not loaded after waiting.");
    }
    return;
  }
  swiper = new Swiper(".main-swiper", {
    direction: "vertical",
    slidesPerView: 1,

    effect: "fade",
    speed: 200,
    preloadImages: false,
    fadeEffect: {
      crossFade: true,
    },

    allowTouchMove: false,

    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },

    on: {
      slideChange() {
        loadSlideLazy(this.activeIndex);

        if (this.isEnd) {
          $(".open").addClass("show");
        } else {
          $(".open").removeClass("show");

          $(".nth-ld-25-ld-footer").removeClass("active");
        }
      },
      slideChangeTransitionStart() {
        const spd =
          this && this.params && typeof this.params.speed === "number"
            ? this.params.speed
            : 200;
        const el = document.querySelector(".main-swiper");
        if (el) {
          el.style.transition = `transform ${spd}ms ease`;
          el.style.willChange = "transform";

          requestAnimationFrame(() => {
            el.style.transform = "scale(1.02)";
          });
        }
      },
      slideChangeTransitionEnd() {
        const el = document.querySelector(".main-swiper");
        if (el) {
          el.style.transform = "scale(1)";
        }
      },
    },
  });

  const containerEl = document.querySelector(".main-swiper");
  if (containerEl) {
    containerEl.dataset.swiperInitialized = "1";
    const spd =
      swiper && swiper.params && typeof swiper.params.speed === "number"
        ? swiper.params.speed
        : 200;
    containerEl.style.transition = `transform ${spd}ms ease`;
    containerEl.style.willChange = "transform";
  }
}

initMainSwiper();

window.addEventListener("load", function () {
  if ($("#MS__wrapper.iframe").length > 0) return;

  initMainSwiper();

  function wireNavToSwiper(retry = 0) {
    if (!swiper) {
      if (retry < 20)
        setTimeout(function () {
          wireNavToSwiper(retry + 1);
        }, 100);
      return;
    }

    const navEls = document.querySelectorAll("[data-slide]");

    function syncActive(index) {
      navEls.forEach(function (el) {
        const slide = parseInt(el.dataset.slide, 10);
        el.classList.toggle("active", slide === index);
      });

      const fr = document.getElementById("libraryMainsite-t-float_right");
      if (fr) fr.classList.toggle("fr-on", index === 0);
    }

    navEls.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        const index = parseInt(el.dataset.slide, 10);
        if (isNaN(index)) return;

        $(".mb-menu-overlay").removeClass("active");
        if (swiper && !swiper.destroyed) {
          const spd =
            swiper.params && typeof swiper.params.speed === "number"
              ? swiper.params.speed
              : 200;
          swiper.slideTo(index, spd);
        }
        syncActive(index);
      });
    });

    swiper.on("slideChange", function () {
      syncActive(swiper.activeIndex);
    });

    const hashNav = Array.from(navEls).find(function (el) {
      return location.hash && el.hash === location.hash;
    });
    if (hashNav) swiper.slideTo(parseInt(hashNav.dataset.slide, 10), 0);

    syncActive(swiper.activeIndex || 0);
    loadSlideLazy(swiper.activeIndex || 0);
  }
  wireNavToSwiper();

  const EDGE_EPS = 2;
  const TOUCH_THRESHOLD = 70;
  const TRANSITION_LOCK = 40;

  function getScrollableAncestor(el) {
    while (el && el !== document.body && el !== document.documentElement) {
      const st = getComputedStyle(el);
      if (
        (st.overflowY === "auto" || st.overflowY === "scroll") &&
        el.scrollHeight > el.clientHeight
      ) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  function atTop(el) {
    return !el || el.scrollTop <= EDGE_EPS;
  }
  function atBottom(el) {
    if (!el) return true;
    return el.scrollTop + el.clientHeight >= el.scrollHeight - EDGE_EPS;
  }

  const rootEl = document.querySelector(".main-swiper");
  if (!rootEl || !swiper) return;

  let isSliding = false;
  swiper.on("transitionStart", () => {
    isSliding = true;
  });
  swiper.on("transitionEnd", () => {
    setTimeout(() => (isSliding = false), TRANSITION_LOCK);
  });

  let touchStartY = 0;
  let activeScrollable = null;

  rootEl.addEventListener(
    "touchstart",
    (e) => {
      if (e.touches.length !== 1 || isSliding) return;
      touchStartY = e.touches[0].clientY;
      activeScrollable = getScrollableAncestor(e.target);
    },
    { passive: true },
  );

  rootEl.addEventListener(
    "touchend",
    (e) => {
      if (isSliding) return;

      const touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;

      const touchEndY = touch.clientY;
      const deltaY = touchStartY - touchEndY;

      if (Math.abs(deltaY) < TOUCH_THRESHOLD) return;

      if (deltaY > 0) {
        if (atBottom(activeScrollable)) {
          swiper.slideNext();
        }
      } else {
        if (atTop(activeScrollable)) {
          swiper.slidePrev();
        }
      }

      activeScrollable = null;
    },
    { passive: true },
  );

  let facesAutoplayTimeout;
  let isUserInteracting = false;

  function clearFacesAutoplay() {
    if (!facesAutoplayTimeout) return;
    clearTimeout(facesAutoplayTimeout);
    facesAutoplayTimeout = null;
  }

  function scheduleFacesAutoplay() {
    clearFacesAutoplay();
    const facesSwiper = document.querySelector(".swiper-faces")?.swiper;
    if (!facesSwiper || isUserInteracting) return;
    if (!facesSwiper.slides || facesSwiper.slides.length <= 1) return;
    facesAutoplayTimeout = setTimeout(() => {
      if (document.hidden) {
        clearFacesAutoplay();
        return;
      }
      if (facesSwiper && !isUserInteracting) {
        facesSwiper.slideNext();
      }
      scheduleFacesAutoplay();
    }, 3000);
  }

  function maybeStartFacesAutoplay() {
    if (document.hidden) return;
    scheduleFacesAutoplay();
  }

  swiper.on("touchStart", () => {
    isUserInteracting = true;
    clearFacesAutoplay();
  });

  swiper.on("touchEnd", () => {
    isUserInteracting = false;
    maybeStartFacesAutoplay();
  });

  swiper.on("slideChange", () => {
    const facesThumbSlides = document.querySelectorAll(
      "#nth-ld-25-ld-faces .content .swiper-faces-thumb .swiper-slide",
    );
    const isFacesSlide = swiper.activeIndex === swiper.slides.length - 2;
    facesThumbSlides.forEach((slide) => {
      slide.style.pointerEvents = isFacesSlide ? "auto" : "none";
    });
    if (isFacesSlide) {
      maybeStartFacesAutoplay();
    } else {
      clearFacesAutoplay();
    }
  });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      clearFacesAutoplay();
    } else if (swiper && swiper.activeIndex === swiper.slides.length - 2) {
      maybeStartFacesAutoplay();
    }
  });

  window.addEventListener("beforeunload", () => {
    clearFacesAutoplay();
  });
  window.addEventListener("pagehide", () => {
    clearFacesAutoplay();
  });

  if (!isMobileDevice()) {
    (function setupMainWheelLogger() {
      const root = document.querySelector(".main-swiper");
      if (!root || root._mainWheelLoggerAttached) return;
      root._mainWheelLoggerAttached = true;

      const LINE_HEIGHT = 16;
      const MIN_ABS = 30;
      const LOCK_MS = 600;
      let lockUntil = 0;

      function normalizeDelta(e) {
        let dx = e.deltaX,
          dy = e.deltaY;
        if (e.deltaMode === 1) {
          dx *= LINE_HEIGHT;
          dy *= LINE_HEIGHT;
        } else if (e.deltaMode === 2) {
          dx *= window.innerWidth;
          dy *= window.innerHeight;
        }
        return { dx, dy };
      }

      root.addEventListener(
        "wheel",
        (e) => {
          if (e.defaultPrevented) return;
          const { dx, dy } = normalizeDelta(e);
          if (Math.abs(dy) < Math.abs(dx)) return;
          if (Math.abs(dy) < MIN_ABS) return;

          const now = Date.now();
          if (now < lockUntil || isSliding) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          const scrollable = getScrollableAncestor(e.target);
          if (dy > 0) {
            if (scrollable && !atBottom(scrollable)) return;
          } else {
            if (scrollable && !atTop(scrollable)) return;
          }

          const dir = dy > 0 ? "next" : "prev";

          if (swiper && !swiper.destroyed) {
            const spd =
              swiper.params && typeof swiper.params.speed === "number"
                ? swiper.params.speed
                : 200;
            if (dir === "next") {
              swiper.slideNext(spd, true);
            } else {
              swiper.slidePrev(spd, true);
            }
          }
          lockUntil = now + LOCK_MS;

          e.preventDefault();
          e.stopPropagation();
        },
        { passive: false },
      );
    })();

    function attachInnerWheelGuard(innerEl) {
      if (!innerEl || innerEl._innerWheelGuardAttached) return;
      const innerSwiper = innerEl.swiper;
      if (!innerSwiper) return;
      innerEl._innerWheelGuardAttached = true;
      let innerLockUntil = 0;
      let innerIsSliding = false;
      const WHEEL_LOCK = 600;
      const LINE_HEIGHT = 16;
      const MIN_ABS = 30;

      const spdInner =
        innerSwiper.params && typeof innerSwiper.params.speed === "number"
          ? innerSwiper.params.speed
          : 200;
      innerEl.style.transition = `transform ${spdInner}ms ease`;
      innerEl.style.willChange = "transform";
      innerSwiper.on("transitionStart", () => {
        innerIsSliding = true;
      });
      innerSwiper.on("transitionEnd", () => {
        innerIsSliding = false;
      });
      innerSwiper.on("slideChangeTransitionStart", () => {
        requestAnimationFrame(() => {
          innerEl.style.transform = "scale(1.02)";
        });
      });
      innerSwiper.on("slideChangeTransitionEnd", () => {
        innerEl.style.transform = "scale(1)";
      });

      function normalizeDelta(e) {
        let dx = e.deltaX,
          dy = e.deltaY;
        if (e.deltaMode === 1) {
          dx *= LINE_HEIGHT;
          dy *= LINE_HEIGHT;
        } else if (e.deltaMode === 2) {
          dx *= window.innerWidth;
          dy *= window.innerHeight;
        }
        return { dx, dy };
      }

      innerEl.addEventListener(
        "wheel",
        function (e) {
          if (!innerSwiper || innerSwiper.destroyed) return;
          const { dx, dy } = normalizeDelta(e);
          if (Math.abs(dy) < Math.abs(dx)) return;
          if (Math.abs(dy) < MIN_ABS) return;

          const now = Date.now();
          if (now < innerLockUntil || innerIsSliding) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          if (dy > 0 && !innerSwiper.isEnd) {
            const spd =
              innerSwiper.params && typeof innerSwiper.params.speed === "number"
                ? innerSwiper.params.speed
                : 200;
            innerSwiper.slideNext(spd, true);
            innerLockUntil = now + WHEEL_LOCK;
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          if (dy < 0 && !innerSwiper.isBeginning) {
            const spd =
              innerSwiper.params && typeof innerSwiper.params.speed === "number"
                ? innerSwiper.params.speed
                : 200;
            innerSwiper.slidePrev(spd, true);
            innerLockUntil = now + WHEEL_LOCK;
            e.preventDefault();
            e.stopPropagation();
            return;
          }
        },
        { passive: false },
      );
    }
    function scanAndAttachInnerSwipers() {
      document.querySelectorAll(".main-swiper .swiper").forEach((el) => {
        if (el.classList.contains("main-swiper")) return;
        attachInnerWheelGuard(el);
      });
    }

    scanAndAttachInnerSwipers();

    const mo = new MutationObserver(() => scanAndAttachInnerSwipers());
    const mainSwiperEl = document.querySelector(".main-swiper");
    if (mainSwiperEl) {
      mo.observe(mainSwiperEl, { childList: true, subtree: true });
    }
  }
});
